import {NgModule} from '@angular/core'
import {PipesModule} from '../../../shared/pipes/pipes.module'
import {CalculatorsService} from './calculators.service'
import {CalculatorsRoutingModule} from './calculators.routing.module'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {CalculatorCloseConfirmationComponent} from './calculator-navbar/calculator-close-confirmation.component'
import {CalculatorNavbarComponent} from './calculator-navbar/calculator-navbar.component'
import {ErneuerbarheizenCalculatorPageComponent} from './erneuerbarheizen-calculator-page/erneuerbarheizen-calculator-page.component'
import {TranslocoModule} from '@ngneat/transloco'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {DialogModule} from '../../../craft/dialog/dialog.module'

@NgModule({
  declarations: [
    CalculatorCloseConfirmationComponent,
    CalculatorNavbarComponent,
    ErneuerbarheizenCalculatorPageComponent,
  ],
  imports: [
    CalculatorsRoutingModule,
    PipesModule,
    FontAwesomeModule,
    PipesModule,
    TranslocoModule,
    CommonModule,
    NgOptimizedImage,
    DialogModule,
  ],
  providers: [CalculatorsService],
})
export class CalculatorsModule {}
